import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  loginRequest: ['payload', 'history'],
  loginSuccess: ['response'],
  loginFailure: null,

  registerDeviceTokenRequest: ['payload'],

  registerDeviceTokenSuccess: ['deviceToken'],
  registerDeviceTokenFailure: null,

  logoutRequest: ['redirectUrl'],
  logoutSuccess: null,
  logoutFailure: null,

  setPasswordRequest: ['payload'],
  setPasswordSuccess: ['response'],
  setPasswordFailure: ['message'],

  forgotPasswordRequest: ['payload'],
  forgotPasswordSuccess: null,
  forgotPasswordFailure: null,

  resetPasswordRequest: ['payload'],
  resetPasswordSuccess: null,
  resetPasswordFailure: ['message'],

  updateUserInformationRequest: ['payload', 'user'],
  updateUserInformationSuccess: ['response'],
  updateUserInformationFailure: null,

  setUpdatedUser: ['userId', 'payload'],

  getMyCompanyRequest: null,
  getMyCompanySuccess: ['response'],
  getMyCompanyFailure: null,

  updatePasswordRequest: ['payload'],
  updatePasswordSuccess: ['response'],
  updatePasswordFailure: null,

  acceptInviteRequest: ['payload'],
  acceptInviteSuccess: ['response'],
  acceptInviteFailure: ['payload'],

  // Clear all caches
  clearRequest: null,
  clearAuthRequest: null,
});

export const AuthTypes = Types;
export default Creators;
